import { Box, Typography } from '@mui/material';
import React from 'react';

interface InspectorGroupProps {
  title: string;
  icon?: React.ReactNode;
  /** One line under the fields, for anything the fields cannot say themselves. */
  hint?: string;
  /** `danger` marks a destructive group (its icon takes the error colour). Calm, not loud. */
  tone?: 'default' | 'danger';
  children: React.ReactNode;
}

/**
 * One titled group inside the inspector. The shell's groups are Identity ·
 * Classification · Placeholders · Versions; editors compose these rather than
 * inventing their own panel chrome.
 */
const InspectorGroup: React.FC<InspectorGroupProps> = ({ title, icon, hint, tone = 'default', children }) => (
  <Box className={`cc-ed__group${tone === 'danger' ? ' cc-ed__group--danger' : ''}`}>
    <Box className="cc-ed__group-head">
      {icon && <span className="cc-ed__group-icon">{icon}</span>}
      <Typography component="span" className="cc-ed__group-title">
        {title}
      </Typography>
    </Box>
    <Box className="cc-ed__group-body">{children}</Box>
    {hint && <p className="cc-ed__hint cc-ed__group-hint">{hint}</p>}
  </Box>
);

export default InspectorGroup;
